module.exports = __webpack_public_path__ + "static/media/mssg_getstarted_en_US.842227d4.PNG";